
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $65168f0452925da7$exports = {};

$parcel$export($65168f0452925da7$exports, "basistheory", () => $65168f0452925da7$export$cbe2892587230861);
const $367e4a81566d966b$export$af88d00dbe7f521 = (()=>{
    const ddTok = 'pubb96b84a13912504f4354f2d794ea4fab';
    let _disableTelemetry;
    let _baseUrl;
    const _log = async (message, level, attributes = {})=>{
        if (_disableTelemetry) return;
        let env;
        if (!_baseUrl || _baseUrl?.includes('localhost')) env = 'local';
        else if (_baseUrl.includes('dev')) env = 'dev';
        else env = 'prod';
        const payload = {
            level: // dd info
            level,
            message: message,
            // for basis theory tracking
            service: 'web-elements-loader',
            env: env,
            // browser information
            referrer: document?.referrer,
            origin: window?.location.origin,
            url: window?.location.href,
            userAgent: navigator?.userAgent,
            // custom values
            ...attributes
        };
        if ([
            'local',
            'dev'
        ].includes(env)) console.log(payload);
        try {
            await fetch(`https://http-intake.logs.datadoghq.com/v1/input/${ddTok}`, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        } catch  {
            // eslint-disable-next-line no-console
            console.warn('There was an error sending telemetry.');
        }
    };
    const disableTelemetry = (val)=>{
        _disableTelemetry = val;
    };
    const setBaseUrl = (baseUrl)=>{
        _baseUrl = baseUrl;
    };
    return {
        disableTelemetry: disableTelemetry,
        setBaseUrl: setBaseUrl,
        log: {
            error: (message, attributes = {})=>_log(message, 'error', attributes),
            info: (message, attributes = {})=>_log(message, 'info', attributes),
            warn: (message, attributes = {})=>_log(message, 'warn', attributes)
        }
    };
})();


class $16b549d313b97bf4$export$925a29a6f046f0b5 extends Error {
    constructor(message, details, /**
     * @deprecated use {@link details}
     */ validation){
        super(message), this.details = details, this.validation = validation;
        this.name = 'BasisTheoryValidationError';
        Object.setPrototypeOf(this, $16b549d313b97bf4$export$925a29a6f046f0b5.prototype);
    }
}


const $c03aa13093e09dc3$export$8ec0597b01ce7a1a = (domain)=>{
    if (typeof domain !== 'string' || !domain.trim()) throw new Error('Custom domain must be a non-empty string.');
    let url;
    try {
        url = new URL(domain.toLowerCase().startsWith('http') ? domain : `https://${domain}`);
    } catch  {
        throw new (0, $16b549d313b97bf4$export$925a29a6f046f0b5)(`Invalid custom domain: "${domain}"`, {});
    }
    if (url.protocol !== 'https:') throw new (0, $16b549d313b97bf4$export$925a29a6f046f0b5)(`Custom domain must use HTTPS (got "${url.protocol}")`, {});
    if (url.pathname !== '/' || url.search || url.hash) throw new (0, $16b549d313b97bf4$export$925a29a6f046f0b5)(`Custom domain must not include path, query, or hash (got "${url.href}")`, {});
    if (url.port) throw new (0, $16b549d313b97bf4$export$925a29a6f046f0b5)(`Custom domain must not include a port (got ":${url.port}")`, {});
    const hostRegex = /^(?=.{1,253}$)([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}$/;
    if (!hostRegex.test(url.hostname)) throw new (0, $16b549d313b97bf4$export$925a29a6f046f0b5)(`Invalid hostname: "${url.hostname}"`, {});
    return url.origin;
};


const $0da125a57a8274fc$export$74dcf80d122cf64e = (url)=>{
    const existingScript = document.querySelector(`script[src^="${url}"]`);
    if (existingScript) return existingScript;
    const parent = document.head || document.body;
    if (!parent) throw new Error('No <head> or <body> elements found in the document.');
    const script = Object.assign(document.createElement('script'), {
        src: url
    });
    parent.append(script);
    return script;
};


const $2e9038c0999bba06$export$6b1a35ff3caa965f = 'Tried to load BasisTheoryElements in a non-DOM environment.';
const $2e9038c0999bba06$export$e3797f3a93015b7b = 'Basis Theory Elements did not load properly. Check network tab for more details.';
const $2e9038c0999bba06$export$56e79dc97980170 = 'Unable to load the Elements script. This may be due to network restrictions or browser extensions like ad blockers interfering with script loading. Check browser settings or network connection and try again.';
const $2e9038c0999bba06$export$9fe15478e8fc6bac = 'Failed to deliver Elements script from Basis Theory. Check your network connection and try again or contact support@basistheory.com';
const $2e9038c0999bba06$export$51be6d94c4fcf45 = [
    'accel',
    'bancontact',
    'cartes-bancaires',
    'culiance',
    'dankort',
    'ebt',
    'eftpos-australia',
    'nyce',
    'private-label',
    'prop',
    'pulse',
    'rupay',
    'star',
    'uatp',
    'korean-local',
    'visa',
    'mastercard',
    'american-express',
    'discover',
    'diners-club',
    'jcb',
    'unionpay',
    'maestro',
    'elo',
    'hiper',
    'hipercard',
    'mir',
    'unknown'
];
const $2e9038c0999bba06$export$829c91d8f039f695 = [
    'left',
    'right',
    'none'
];
// https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
const $2e9038c0999bba06$export$dea6ebbc92df4fa3 = [
    'additional-name',
    'address-level1',
    'address-level2',
    'address-level3',
    'address-level4',
    'address-line1',
    'address-line2',
    'address-line3',
    'bday-day',
    'bday-month',
    'bday-year',
    'bday',
    'billing',
    'cc-additional-name',
    'cc-csc',
    'cc-exp-month',
    'cc-exp-year',
    'cc-exp',
    'cc-family-name',
    'cc-given-name',
    'cc-name',
    'cc-number',
    'cc-type',
    'country-name',
    'country',
    'current-password',
    'email',
    'family-name',
    'fax',
    'given-name',
    'home',
    'honorific-prefix',
    'honorific-suffix',
    'language',
    'mobile',
    'name',
    'new-password',
    'nickname',
    'off',
    'on',
    'one-time-code',
    'organization-title',
    'organization',
    'page',
    'postal-code',
    'sex',
    'shipping',
    'street-address',
    'tel-area-code',
    'tel-country-code',
    'tel-extension',
    'tel-local-prefix',
    'tel-local-suffix',
    'tel-local',
    'tel-national',
    'tel',
    'transaction-amount',
    'transaction-currency',
    'url',
    'username',
    'work'
];




let $2cc07a9862fd14af$var$elementsPromise;
const $2cc07a9862fd14af$var$loadScript = (url, retryCount)=>new Promise((resolve, reject)=>{
        let script = (0, $0da125a57a8274fc$export$74dcf80d122cf64e)(url);
        // flag to prevent double rejection (if somehow script was not removed)
        let isSettled = false;
        // script load success
        script.addEventListener('load', ()=>{
            if (window.BasisTheoryElements) resolve(window.BasisTheoryElements);
            else {
                (async ()=>{
                    await (0, $367e4a81566d966b$export$af88d00dbe7f521).log.error('Elements not found on window on load', {
                        logType: 'elementsNotFoundOnWindow',
                        logOrigin: 'loadScript',
                        retryCount: retryCount
                    });
                })();
                reject(new Error((0, $2e9038c0999bba06$export$e3797f3a93015b7b)));
            }
        });
        // script error event
        script.addEventListener('error', async (event)=>{
            if (isSettled) return;
            isSettled = true;
            await (0, $367e4a81566d966b$export$af88d00dbe7f521).log.error('Elements script onError event', {
                logType: 'elementsScriptOnError',
                logOrigin: 'loadScript',
                retryCount: retryCount,
                event: {
                    message: event?.message,
                    source: event?.filename,
                    lineno: event?.lineno,
                    colno: event?.colno,
                    error: event?.error,
                    target: event?.target
                }
            });
            // remove from dom to avoid duplicates
            try {
                script?.remove();
            } catch (error) {
                await (0, $367e4a81566d966b$export$af88d00dbe7f521).log.error(`Error removing script from DOM on retry attempt ${retryCount}`, {
                    logType: 'scriptRemovalError',
                    logOrigin: 'loadScript',
                    retryCount: retryCount,
                    removalError: error
                });
            }
            // retry 1x if first attempt
            if (retryCount === 0) {
                $2cc07a9862fd14af$var$loadScript(url, retryCount + 1).then(resolve).catch(reject);
                return;
            }
            // second attempt has failed: try fetching the script to inspect the response
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    await (0, $367e4a81566d966b$export$af88d00dbe7f521).log.error(`Second attempt to load elements script failed, fetch failed with status: ${response.status}.`, {
                        logType: 'elementsScriptFetchFailure',
                        logOrigin: 'loadScript',
                        retryCount: retryCount,
                        fetchResult: 'error',
                        fetchResponse: response
                    });
                    reject(new Error((0, $2e9038c0999bba06$export$6b1a35ff3caa965f)));
                } else {
                    await (0, $367e4a81566d966b$export$af88d00dbe7f521).log.error(`Second attempt to load elements script failed, fetch success`, {
                        logType: 'elementsScriptFetchFailure',
                        logOrigin: 'loadScript',
                        retryCount: retryCount,
                        fetchResult: 'success',
                        fetchResponse: response
                    });
                    reject(new Error((0, $2e9038c0999bba06$export$56e79dc97980170)));
                }
            } catch (error) {
                // fetch also failed
                await (0, $367e4a81566d966b$export$af88d00dbe7f521).log.error('Second attempt failed to load elements script failed, fetch network error.', {
                    logType: 'elementsScriptFetchError',
                    logOrigin: 'loadScript',
                    retryCount: retryCount,
                    fetchResult: 'error',
                    fetchError: error
                });
                reject(new Error((0, $2e9038c0999bba06$export$56e79dc97980170)));
            }
            // ultimately reject with browser message
            reject(event?.error || event?.message || new Error((0, $2e9038c0999bba06$export$56e79dc97980170)));
        });
    });
const $2cc07a9862fd14af$export$2b0a6e5a1c78018f = (elementsUrl)=>{
    if (!$2cc07a9862fd14af$var$elementsPromise) $2cc07a9862fd14af$var$elementsPromise = new Promise((resolve, reject)=>{
        if (typeof window !== 'object') {
            (async ()=>{
                await (0, $367e4a81566d966b$export$af88d00dbe7f521).log.warn((0, $2e9038c0999bba06$export$6b1a35ff3caa965f), {
                    logType: 'elementsNonDomError',
                    logOrigin: 'loadElements'
                });
                reject(new Error((0, $2e9038c0999bba06$export$6b1a35ff3caa965f)));
            })();
            return;
        }
        if (window.BasisTheoryElements) {
            resolve(window.BasisTheoryElements);
            return;
        }
        const url = new URL(elementsUrl).toString().replace(/\/$/u, '');
        $2cc07a9862fd14af$var$loadScript(url, 0).then(resolve).catch((error)=>{
            reject(error);
        });
    });
    return $2cc07a9862fd14af$var$elementsPromise;
};




// Build-time generated URLs for regular deployment
const $c9bd4b894cc03378$export$67c92c3b857d033a = null;
const $c9bd4b894cc03378$export$9c5c779c8690dca6 = null;


// Auto-generated version file
const $6a2f0bfcc5905f21$export$83d89fbfd8236492 = '2.5.0';


const $65168f0452925da7$var$TEST_ORIGIN = 'https://js.flock-dev.com';
const $65168f0452925da7$var$DEFAULT_ORIGIN = 'https://js.basistheory.com';
const $65168f0452925da7$var$resolveUrls = (options)=>{
    if (options?._devMode && options?.customDomain) console.warn('Dev mode and domain whitelabeling are both enabled - dev mode takes precedence.');
    let origin;
    if (options?._devMode) origin = $65168f0452925da7$var$TEST_ORIGIN;
    else if (options?.customDomain) origin = (0, $c03aa13093e09dc3$export$8ec0597b01ce7a1a)(options.customDomain);
    else origin = $65168f0452925da7$var$DEFAULT_ORIGIN;
    const base = `${origin}/web-elements/${(0, $6a2f0bfcc5905f21$export$83d89fbfd8236492)}`;
    const client = `${base}/client/index.js`;
    const hosted = `${base}/hosted-elements/`;
    if (options?.customDomain && !options._devMode) return {
        origin: origin,
        clientJsUrl: client,
        hostedElementsBaseUrl: hosted
    };
    return {
        origin: origin,
        clientJsUrl: (0, $c9bd4b894cc03378$export$67c92c3b857d033a) ?? client,
        hostedElementsBaseUrl: (0, $c9bd4b894cc03378$export$9c5c779c8690dca6) ?? hosted
    };
};
const $65168f0452925da7$export$cbe2892587230861 = async (apiKey, options)=>{
    if (!apiKey || apiKey.length === 0) throw new Error('API key is required');
    const { origin: origin, clientJsUrl: clientJsUrl, hostedElementsBaseUrl: hostedElementsBaseUrl } = $65168f0452925da7$var$resolveUrls(options);
    (0, $367e4a81566d966b$export$af88d00dbe7f521).setBaseUrl(origin);
    (0, $367e4a81566d966b$export$af88d00dbe7f521).disableTelemetry(Boolean(options?.disableTelemetry));
    const elements = await (0, $2cc07a9862fd14af$export$2b0a6e5a1c78018f)(clientJsUrl);
    return elements.init(apiKey, hostedElementsBaseUrl, false, options?.useSameOriginApi ?? true, options?.disableTelemetry ?? false, options?.debug ?? false, options?.useUat ?? false, options?.useNetworkCheck ?? false, options?.customDomain ? origin : undefined);
};


var $e8df50a6ced49e58$exports = {};

$parcel$export($e8df50a6ced49e58$exports, "AUTOCOMPLETE_VALUES", () => $2e9038c0999bba06$export$dea6ebbc92df4fa3);
$parcel$export($e8df50a6ced49e58$exports, "CARD_BRANDS", () => $2e9038c0999bba06$export$51be6d94c4fcf45);
$parcel$export($e8df50a6ced49e58$exports, "CARD_ICON_POSITIONS", () => $2e9038c0999bba06$export$829c91d8f039f695);
var $8142f8fc8bbedd0b$exports = {};
var $6011935a2a75da1d$exports = {};

$parcel$export($6011935a2a75da1d$exports, "VISA", () => $6011935a2a75da1d$export$1748c2651c2c6e25);
$parcel$export($6011935a2a75da1d$exports, "MASTERCARD", () => $6011935a2a75da1d$export$1c604828de4cf9cf);
$parcel$export($6011935a2a75da1d$exports, "AMERICAN_EXPRESS", () => $6011935a2a75da1d$export$67c5e4e99638ee87);
$parcel$export($6011935a2a75da1d$exports, "DINERS_CLUB", () => $6011935a2a75da1d$export$fcf88132c9601d5d);
$parcel$export($6011935a2a75da1d$exports, "DISCOVER", () => $6011935a2a75da1d$export$27b2e48e28163360);
$parcel$export($6011935a2a75da1d$exports, "JCB", () => $6011935a2a75da1d$export$bf30f1ca7b266454);
$parcel$export($6011935a2a75da1d$exports, "UNION_PAY", () => $6011935a2a75da1d$export$8ed8e9ea6bbca19f);
$parcel$export($6011935a2a75da1d$exports, "MAESTRO", () => $6011935a2a75da1d$export$f08651c87c943e8);
$parcel$export($6011935a2a75da1d$exports, "ELO", () => $6011935a2a75da1d$export$c4b8f606caaecf2c);
$parcel$export($6011935a2a75da1d$exports, "MIR", () => $6011935a2a75da1d$export$58f9d4150439d06e);
$parcel$export($6011935a2a75da1d$exports, "HIPER", () => $6011935a2a75da1d$export$8f50e2757841117b);
$parcel$export($6011935a2a75da1d$exports, "HIPERCARD", () => $6011935a2a75da1d$export$adb072c9761d9e59);
$parcel$export($6011935a2a75da1d$exports, "DEFAULT_CARD_TYPES", () => $6011935a2a75da1d$export$35b475386df8059d);
const $6011935a2a75da1d$export$1748c2651c2c6e25 = {
    niceType: 'Visa',
    type: 'visa',
    patterns: [
        4
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        16,
        18,
        19
    ],
    code: {
        name: 'CVV',
        size: 3
    }
};
const $6011935a2a75da1d$export$1c604828de4cf9cf = {
    niceType: 'Mastercard',
    type: 'mastercard',
    patterns: [
        [
            51,
            55
        ],
        [
            2221,
            2229
        ],
        [
            223,
            229
        ],
        [
            23,
            26
        ],
        [
            270,
            271
        ],
        2720
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        16
    ],
    code: {
        name: 'CVC',
        size: 3
    }
};
const $6011935a2a75da1d$export$67c5e4e99638ee87 = {
    niceType: 'American Express',
    type: 'american-express',
    patterns: [
        34,
        37
    ],
    gaps: [
        4,
        10
    ],
    lengths: [
        15
    ],
    code: {
        name: 'CID',
        size: 4
    }
};
const $6011935a2a75da1d$export$fcf88132c9601d5d = {
    niceType: 'Diners Club',
    type: 'diners-club',
    patterns: [
        [
            300,
            305
        ],
        36,
        38,
        39
    ],
    gaps: [
        4,
        10
    ],
    lengths: [
        14,
        16,
        19
    ],
    code: {
        name: 'CVV',
        size: 3
    }
};
const $6011935a2a75da1d$export$27b2e48e28163360 = {
    niceType: 'Discover',
    type: 'discover',
    patterns: [
        6011,
        [
            644,
            649
        ],
        65
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        16,
        19
    ],
    code: {
        name: 'CID',
        size: 3
    }
};
const $6011935a2a75da1d$export$bf30f1ca7b266454 = {
    niceType: 'JCB',
    type: 'jcb',
    patterns: [
        2131,
        1800,
        [
            3528,
            3589
        ]
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        16,
        17,
        18,
        19
    ],
    code: {
        name: 'CVV',
        size: 3
    }
};
const $6011935a2a75da1d$export$8ed8e9ea6bbca19f = {
    niceType: 'UnionPay',
    type: 'unionpay',
    patterns: [
        620,
        [
            62100,
            62182
        ],
        [
            62184,
            62187
        ],
        [
            62185,
            62197
        ],
        [
            62200,
            62205
        ],
        [
            622010,
            622999
        ],
        622018,
        [
            62207,
            62209
        ],
        [
            623,
            626
        ],
        6270,
        6272,
        6276,
        [
            627700,
            627779
        ],
        [
            627781,
            627799
        ],
        [
            6282,
            6289
        ],
        6291,
        6292,
        810,
        [
            8110,
            8131
        ],
        [
            8132,
            8151
        ],
        [
            8152,
            8163
        ],
        [
            8164,
            8171
        ]
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        14,
        15,
        16,
        17,
        18,
        19
    ],
    code: {
        name: 'CVN',
        size: 3
    }
};
const $6011935a2a75da1d$export$f08651c87c943e8 = {
    niceType: 'Maestro',
    type: 'maestro',
    patterns: [
        493698,
        [
            500000,
            504174
        ],
        [
            504176,
            506698
        ],
        [
            506779,
            508999
        ],
        [
            56,
            59
        ],
        63,
        67,
        6
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19
    ],
    code: {
        name: 'CVC',
        size: 3
    }
};
const $6011935a2a75da1d$export$c4b8f606caaecf2c = {
    niceType: 'Elo',
    type: 'elo',
    patterns: [
        401178,
        401179,
        438935,
        457631,
        457632,
        431274,
        451416,
        457393,
        504175,
        [
            506699,
            506778
        ],
        [
            509000,
            509999
        ],
        627780,
        636297,
        636368,
        [
            650031,
            650033
        ],
        [
            650035,
            650051
        ],
        [
            650405,
            650439
        ],
        [
            650485,
            650538
        ],
        [
            650541,
            650598
        ],
        [
            650700,
            650718
        ],
        [
            650720,
            650727
        ],
        [
            650901,
            650978
        ],
        [
            651652,
            651679
        ],
        [
            655000,
            655019
        ],
        [
            655021,
            655058
        ]
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        16
    ],
    code: {
        name: 'CVE',
        size: 3
    }
};
const $6011935a2a75da1d$export$58f9d4150439d06e = {
    niceType: 'Mir',
    type: 'mir',
    patterns: [
        [
            2200,
            2204
        ]
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        16,
        17,
        18,
        19
    ],
    code: {
        name: 'CVP2',
        size: 3
    }
};
const $6011935a2a75da1d$export$8f50e2757841117b = {
    niceType: 'Hiper',
    type: 'hiper',
    patterns: [
        637095,
        63737423,
        63743358,
        637568,
        637599,
        637609,
        637612
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        16
    ],
    code: {
        name: 'CVC',
        size: 3
    }
};
const $6011935a2a75da1d$export$adb072c9761d9e59 = {
    niceType: 'Hipercard',
    type: 'hipercard',
    patterns: [
        606282
    ],
    gaps: [
        4,
        8,
        12
    ],
    lengths: [
        16
    ],
    code: {
        name: 'CVC',
        size: 3
    }
};
const $6011935a2a75da1d$export$35b475386df8059d = [
    $6011935a2a75da1d$export$1748c2651c2c6e25,
    $6011935a2a75da1d$export$1c604828de4cf9cf,
    $6011935a2a75da1d$export$67c5e4e99638ee87,
    $6011935a2a75da1d$export$fcf88132c9601d5d,
    $6011935a2a75da1d$export$27b2e48e28163360,
    $6011935a2a75da1d$export$bf30f1ca7b266454,
    $6011935a2a75da1d$export$8ed8e9ea6bbca19f,
    $6011935a2a75da1d$export$f08651c87c943e8,
    $6011935a2a75da1d$export$c4b8f606caaecf2c,
    $6011935a2a75da1d$export$58f9d4150439d06e,
    $6011935a2a75da1d$export$8f50e2757841117b,
    $6011935a2a75da1d$export$adb072c9761d9e59
];


var $a7c0ed47a726bc77$exports = {};

$parcel$export($a7c0ed47a726bc77$exports, "CoBadgedSupport", () => $a7c0ed47a726bc77$export$8dde18ea9019c560);
// Currently only cartes_bancaires is supported
var $a7c0ed47a726bc77$export$8dde18ea9019c560 = /*#__PURE__*/ function(CoBadgedSupport) {
    CoBadgedSupport["CartesBancaires"] = "cartes-bancaires";
    return CoBadgedSupport;
}({});


var $5c7474255e842807$exports = {};


var $aa1f0e8f3ba99285$exports = {};


var $0b7f2ce91f71c8fb$exports = {};

$parcel$export($0b7f2ce91f71c8fb$exports, "ELEMENTS_TYPES", () => $0b7f2ce91f71c8fb$export$8141e4f9a897abe6);
const $0b7f2ce91f71c8fb$export$8141e4f9a897abe6 = [
    'card',
    'cardExpirationDate',
    'cardNumber',
    'cardVerificationCode',
    'copyButton',
    'data',
    'text'
];
var $0b7f2ce91f71c8fb$var$InputMode = /*#__PURE__*/ function(InputMode) {
    InputMode["DECIMAL"] = "decimal";
    InputMode["EMAIL"] = "email";
    InputMode["NONE"] = "none";
    InputMode["NUMERIC"] = "numeric";
    InputMode["SEARCH"] = "search";
    InputMode["TEL"] = "tel";
    InputMode["TEXT"] = "text";
    InputMode["URL"] = "url";
    return InputMode;
}($0b7f2ce91f71c8fb$var$InputMode || {});


var $0d76f51751e4f2ad$exports = {};
var $0c6d355f47a965d8$exports = {};


var $b875617dcfcf7e35$exports = {};


var $2d2d2fbdd48375e5$exports = {};


var $4ed5db2a8eab95d6$exports = {};


$parcel$exportWildcard($0d76f51751e4f2ad$exports, $0c6d355f47a965d8$exports);
$parcel$exportWildcard($0d76f51751e4f2ad$exports, $b875617dcfcf7e35$exports);
$parcel$exportWildcard($0d76f51751e4f2ad$exports, $2d2d2fbdd48375e5$exports);
$parcel$exportWildcard($0d76f51751e4f2ad$exports, $4ed5db2a8eab95d6$exports);


var $5c3fd4ec5ab25a5b$exports = {};


var $ce70703c3ce2f3a0$exports = {};

$parcel$export($ce70703c3ce2f3a0$exports, "SAFE_CSS_PROPERTIES", () => $ce70703c3ce2f3a0$export$e2bf52fc7723ec89);
$parcel$export($ce70703c3ce2f3a0$exports, "BUTTON_CSS_PROPERTIES", () => $ce70703c3ce2f3a0$export$93133f730762aee4);
$parcel$export($ce70703c3ce2f3a0$exports, "SAFE_CSS_PROPERTIES_ALTERNATES", () => $ce70703c3ce2f3a0$export$e22a44f86989e3f4);
$parcel$export($ce70703c3ce2f3a0$exports, "SAFE_CSS_PROPERTIES_WITH_ALTERNATES", () => $ce70703c3ce2f3a0$export$b5b27feb4cf29129);
$parcel$export($ce70703c3ce2f3a0$exports, "CARD_ELEMENT_STYLE_VARIANT_SELECTORS", () => $ce70703c3ce2f3a0$export$fc323aec0bf844b);
$parcel$export($ce70703c3ce2f3a0$exports, "BUTTON_ELEMENT_STYLE_VARIANT_SELECTORS", () => $ce70703c3ce2f3a0$export$8cce4e63ba22bae);
$parcel$export($ce70703c3ce2f3a0$exports, "CARD_ELEMENT_STYLE_VARIANTS", () => $ce70703c3ce2f3a0$export$a15fff7fac404fd9);
$parcel$export($ce70703c3ce2f3a0$exports, "CARD_ELEMENT_STYLE_FONTS_ATTR", () => $ce70703c3ce2f3a0$export$c3a88e1ff160bfd6);
$parcel$export($ce70703c3ce2f3a0$exports, "BUTTON_ELEMENT_STYLE_VARIANTS", () => $ce70703c3ce2f3a0$export$612b2fbe2f6ee5db);
const $ce70703c3ce2f3a0$export$e2bf52fc7723ec89 = [
    'backgroundColor',
    'color',
    'fontFamily',
    'fontSize',
    'fontSmooth',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'letterSpacing',
    'lineHeight',
    'padding',
    'textAlign',
    'textDecoration',
    'textShadow',
    'textTransform'
];
// Button-specific CSS properties for styling interactive buttons
const $ce70703c3ce2f3a0$export$93133f730762aee4 = [
    'alignItems',
    'backgroundColor',
    'border',
    'borderBottom',
    'borderColor',
    'borderLeft',
    'borderRadius',
    'borderRight',
    'borderStyle',
    'borderTop',
    'borderWidth',
    'boxShadow',
    'color',
    'cursor',
    'display',
    'fontFamily',
    'fontSize',
    'fontWeight',
    'gap',
    'height',
    'justifyContent',
    'letterSpacing',
    'lineHeight',
    'margin',
    'maxHeight',
    'maxWidth',
    'minHeight',
    'minWidth',
    'opacity',
    'outline',
    'padding',
    'textAlign',
    'textTransform',
    'transform',
    'transition',
    'width'
];
const $ce70703c3ce2f3a0$export$e22a44f86989e3f4 = {
    fontSmooth: [
        '-webkit-font-smoothing',
        '-moz-osx-font-smoothing'
    ]
};
const $ce70703c3ce2f3a0$export$b5b27feb4cf29129 = Object.keys($ce70703c3ce2f3a0$export$e22a44f86989e3f4);
const $ce70703c3ce2f3a0$export$fc323aec0bf844b = [
    ':hover',
    ':focus',
    ':read-only',
    '::placeholder',
    '::selection',
    ':disabled'
];
const $ce70703c3ce2f3a0$export$8cce4e63ba22bae = [
    ':hover',
    ':focus',
    ':active'
];
const $ce70703c3ce2f3a0$export$a15fff7fac404fd9 = [
    'base',
    'container',
    'complete',
    'invalid',
    'empty'
];
const $ce70703c3ce2f3a0$export$c3a88e1ff160bfd6 = 'fonts';
const $ce70703c3ce2f3a0$export$612b2fbe2f6ee5db = [
    'base',
    'container'
];


$parcel$exportWildcard($8142f8fc8bbedd0b$exports, $6011935a2a75da1d$exports);
$parcel$exportWildcard($8142f8fc8bbedd0b$exports, $a7c0ed47a726bc77$exports);
$parcel$exportWildcard($8142f8fc8bbedd0b$exports, $5c7474255e842807$exports);
$parcel$exportWildcard($8142f8fc8bbedd0b$exports, $aa1f0e8f3ba99285$exports);
$parcel$exportWildcard($8142f8fc8bbedd0b$exports, $0b7f2ce91f71c8fb$exports);
$parcel$exportWildcard($8142f8fc8bbedd0b$exports, $0d76f51751e4f2ad$exports);
$parcel$exportWildcard($8142f8fc8bbedd0b$exports, $5c3fd4ec5ab25a5b$exports);
$parcel$exportWildcard($8142f8fc8bbedd0b$exports, $ce70703c3ce2f3a0$exports);


var $cf9609817e6b4989$exports = {};
var $88bdfff2114854bc$exports = {};

$parcel$export($88bdfff2114854bc$exports, "DATA_CLASSIFICATIONS", () => $88bdfff2114854bc$export$f9a8af5874660c13);
$parcel$export($88bdfff2114854bc$exports, "DATA_IMPACT_LEVELS", () => $88bdfff2114854bc$export$7ea51ced9080f153);
$parcel$export($88bdfff2114854bc$exports, "DATA_RESTRICTION_POLICIES", () => $88bdfff2114854bc$export$23716d8c8b579500);
const $88bdfff2114854bc$export$f9a8af5874660c13 = [
    'general',
    'bank',
    'pci',
    'pii'
];
const $88bdfff2114854bc$export$7ea51ced9080f153 = [
    'low',
    'moderate',
    'high'
];
const $88bdfff2114854bc$export$23716d8c8b579500 = [
    'mask',
    'redact'
];


var $7c882e08cb3e9620$exports = {};


var $4ba51567893214f7$exports = {};


var $642d584253558f53$exports = {};


var $cdaaea052a598516$exports = {};


var $faaa8ec69b15b224$exports = {};


var $22da6c8210f1d548$exports = {};
/**
 * Make all properties in T nullable
 */ 

var $36748d22c655727e$exports = {};


$parcel$exportWildcard($cf9609817e6b4989$exports, $88bdfff2114854bc$exports);
$parcel$exportWildcard($cf9609817e6b4989$exports, $7c882e08cb3e9620$exports);
$parcel$exportWildcard($cf9609817e6b4989$exports, $4ba51567893214f7$exports);
$parcel$exportWildcard($cf9609817e6b4989$exports, $642d584253558f53$exports);
$parcel$exportWildcard($cf9609817e6b4989$exports, $cdaaea052a598516$exports);
$parcel$exportWildcard($cf9609817e6b4989$exports, $faaa8ec69b15b224$exports);
$parcel$exportWildcard($cf9609817e6b4989$exports, $22da6c8210f1d548$exports);
$parcel$exportWildcard($cf9609817e6b4989$exports, $36748d22c655727e$exports);


var $85d50d0af47c606f$exports = {};
var $5518afd42ce85a51$exports = {};
var $30bd37a948d996a3$exports = {};


$parcel$exportWildcard($5518afd42ce85a51$exports, $30bd37a948d996a3$exports);


$parcel$exportWildcard($85d50d0af47c606f$exports, $5518afd42ce85a51$exports);



$parcel$exportWildcard($e8df50a6ced49e58$exports, $8142f8fc8bbedd0b$exports);
$parcel$exportWildcard($e8df50a6ced49e58$exports, $cf9609817e6b4989$exports);
$parcel$exportWildcard($e8df50a6ced49e58$exports, $85d50d0af47c606f$exports);


var $fc55d9777ef735a2$exports = {};

$parcel$export($fc55d9777ef735a2$exports, "BasisTheoryApiError", () => $cc8dceaa5ea02f81$export$5a9a4feb38dee587);
$parcel$export($fc55d9777ef735a2$exports, "BasisTheoryValidationError", () => $16b549d313b97bf4$export$925a29a6f046f0b5);
$parcel$export($fc55d9777ef735a2$exports, "BasisTheoryConfigurationError", () => $4a0c7371353b6fff$export$8b56781fadda32af);
$parcel$export($fc55d9777ef735a2$exports, "HttpClientError", () => $3753a300b9392464$export$83d862a6bd4a93c5);
class $cc8dceaa5ea02f81$export$5a9a4feb38dee587 extends Error {
    constructor(message, status, data, _debug){
        super(message), this.status = status, this.data = data, this._debug = _debug;
        this.name = 'BasisTheoryApiError';
        Object.setPrototypeOf(this, $cc8dceaa5ea02f81$export$5a9a4feb38dee587.prototype);
    }
}



class $4a0c7371353b6fff$export$8b56781fadda32af extends Error {
    constructor(message, details){
        super(message), this.details = details;
        this.name = 'BasisTheoryConfigurationError';
        Object.setPrototypeOf(this, $4a0c7371353b6fff$export$8b56781fadda32af.prototype);
    }
}


class $3753a300b9392464$export$83d862a6bd4a93c5 extends Error {
    constructor(message, status, data, headers){
        super(message);
        this.name = 'HttpClientError';
        this.status = status;
        this.data = data;
        this.headers = headers;
        Object.setPrototypeOf(this, $3753a300b9392464$export$83d862a6bd4a93c5.prototype);
    }
}




/**
 * Attaches to window when importing via `<script>` tags.
 */ if (typeof window !== 'undefined' && document.currentScript && !window.basistheory) window.basistheory = (0, $65168f0452925da7$export$cbe2892587230861);


export {$65168f0452925da7$export$cbe2892587230861 as basistheory, $2e9038c0999bba06$export$dea6ebbc92df4fa3 as AUTOCOMPLETE_VALUES, $2e9038c0999bba06$export$51be6d94c4fcf45 as CARD_BRANDS, $2e9038c0999bba06$export$829c91d8f039f695 as CARD_ICON_POSITIONS, $6011935a2a75da1d$export$1748c2651c2c6e25 as VISA, $6011935a2a75da1d$export$1c604828de4cf9cf as MASTERCARD, $6011935a2a75da1d$export$67c5e4e99638ee87 as AMERICAN_EXPRESS, $6011935a2a75da1d$export$fcf88132c9601d5d as DINERS_CLUB, $6011935a2a75da1d$export$27b2e48e28163360 as DISCOVER, $6011935a2a75da1d$export$bf30f1ca7b266454 as JCB, $6011935a2a75da1d$export$8ed8e9ea6bbca19f as UNION_PAY, $6011935a2a75da1d$export$f08651c87c943e8 as MAESTRO, $6011935a2a75da1d$export$c4b8f606caaecf2c as ELO, $6011935a2a75da1d$export$58f9d4150439d06e as MIR, $6011935a2a75da1d$export$8f50e2757841117b as HIPER, $6011935a2a75da1d$export$adb072c9761d9e59 as HIPERCARD, $6011935a2a75da1d$export$35b475386df8059d as DEFAULT_CARD_TYPES, $a7c0ed47a726bc77$export$8dde18ea9019c560 as CoBadgedSupport, $0b7f2ce91f71c8fb$export$8141e4f9a897abe6 as ELEMENTS_TYPES, $ce70703c3ce2f3a0$export$e2bf52fc7723ec89 as SAFE_CSS_PROPERTIES, $ce70703c3ce2f3a0$export$93133f730762aee4 as BUTTON_CSS_PROPERTIES, $ce70703c3ce2f3a0$export$e22a44f86989e3f4 as SAFE_CSS_PROPERTIES_ALTERNATES, $ce70703c3ce2f3a0$export$b5b27feb4cf29129 as SAFE_CSS_PROPERTIES_WITH_ALTERNATES, $ce70703c3ce2f3a0$export$fc323aec0bf844b as CARD_ELEMENT_STYLE_VARIANT_SELECTORS, $ce70703c3ce2f3a0$export$8cce4e63ba22bae as BUTTON_ELEMENT_STYLE_VARIANT_SELECTORS, $ce70703c3ce2f3a0$export$a15fff7fac404fd9 as CARD_ELEMENT_STYLE_VARIANTS, $ce70703c3ce2f3a0$export$c3a88e1ff160bfd6 as CARD_ELEMENT_STYLE_FONTS_ATTR, $ce70703c3ce2f3a0$export$612b2fbe2f6ee5db as BUTTON_ELEMENT_STYLE_VARIANTS, $88bdfff2114854bc$export$f9a8af5874660c13 as DATA_CLASSIFICATIONS, $88bdfff2114854bc$export$7ea51ced9080f153 as DATA_IMPACT_LEVELS, $88bdfff2114854bc$export$23716d8c8b579500 as DATA_RESTRICTION_POLICIES, $cc8dceaa5ea02f81$export$5a9a4feb38dee587 as BasisTheoryApiError, $16b549d313b97bf4$export$925a29a6f046f0b5 as BasisTheoryValidationError, $4a0c7371353b6fff$export$8b56781fadda32af as BasisTheoryConfigurationError, $3753a300b9392464$export$83d862a6bd4a93c5 as HttpClientError};
